// module is a simplified tabs copy
const radioSwitcher = (() => {
    const _o = {
        selectors: {
            observer: '[data-radio-switcher]',
            trigger: '[data-radio-trigger]'
        },
        classes: {
            active: 'is-active'
        }
    };

    let elements = [];

    const init = () => {
        document.querySelectorAll(_o.selectors.observer).forEach(el => processElement(el));
    };

    const processElement = (el) => {
        const element = {
            element: el,
            triggers: [],
            contents: [],
            active: {
                trigger: null,
                content: null
            }
        };

        el.querySelectorAll(_o.selectors.trigger).forEach( (elem) => {
            const targetID = elem.dataset.radioTrigger;

            const tempContent = {
                id: targetID,
                el: document.getElementById(`content-${targetID}`)
            };

            element.triggers.push(elem);
            element.contents.push(tempContent);

            initEvents(elem, element);
        });

        elements.push(element);
    };

    const initEvents = (trigger, element) => {
        trigger.addEventListener('click', (e) => onClickTab(e, trigger, element));
    };

    const onClickTab = (e, trigger, element) => {
        element.triggers.forEach((el, i) => {
            if (el === trigger) activeTabByID(element, i);
        });
    };

    const activeTabByID = (element, index, setFocus = true) => {
        deactiveCurrentTab(element);

        setTimeout(() => {
            // activeTrigger(element.triggers[index], element, index);
            activeContent(element.contents[index], element);

            if (setFocus)
                element.triggers[index].focus();
        }, 0);
    };

    const deactiveCurrentTab = (element) => {
        if(element.active.content) {
            deactiveContent(element);
            // deactiveTrigger(element);
        } 
    };

    const activeContent = (content, element) => {
        console.log(content)
        element.active.content = content;
        content.el.classList.add(_o.classes.active);
    };

    const deactiveContent = (element) => {
        element.active.content.el.classList.remove(_o.classes.active);
        element.active.content = null;
    };

    return {
        init: init,
    };
})();

export { radioSwitcher };
